import { mapGetters } from 'vuex';
//import _ from 'lodash';

import VideoItem from '@/views/Bookmark/components/VideoList/VideoItem.vue';

export default {
  name: 'VideoList',

  components: {
    VideoItem,
  },

  computed: {
    ...mapGetters('Mixins/Bookmark', {
      mg_favoriteList: 'favoriteList',
      mg_readyToPlayVideos: 'readyToPlayVideos',
    }),
  },

  methods: {
    openPlayer() {
      this.$emit('open-player');
    },
  },
};
